import React, { useState } from 'react';
import SymbolInput from 'symbols/components/SymbolInput';
import classNames from 'classnames';

export interface WidgetConfigWithSymbol {
    symbol?: string;
}

export interface WidgetSymbolEditorProps {
    className?: string;
    config: WidgetConfigWithSymbol;
    onChange: (delta: Partial<WidgetConfigWithSymbol>) => void;
}

export default function WidgetSettingsSymbolEditor(
    props: WidgetSymbolEditorProps
) {
    const { className, config, onChange } = props;

    const { symbol } = config;

    const [inputValue, setInputValue] = useState(symbol);

    const onChanged = (enteredText: string) => {
        const nextSymbol = enteredText.toUpperCase();
        setInputValue(nextSymbol);
        onChange({ symbol: nextSymbol });
    };

    const cssClasses = classNames('WidgetSettingsSymbolEditor', className);

    return (
        <div className={cssClasses}>
            <div>Index or Symbol</div>
            <SymbolInput value={inputValue} onChange={onChanged} />
        </div>
    );
}
